import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Accounts_authority = async (accountguid) => {

  if (!accountguid || typeof accountguid !== "string" || accountguid.trim() === "") {
    return { success: false, error: "Missing accountid" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid"); 

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
 

  try {
    const staffRef = collection(db, "accounts", accountguid, "accounts_authority");
    const staffQuery = query(
      staffRef,
      where("guid", "==", accountguid)
    );
    const staffSnap = await getDocs(staffQuery);

    if (staffSnap.empty) {
      return { success: false, error: "Account is not of authority." };
    }

    // fetch from main accounts collection
    const accQuery = query(
      collection(db, "accounts"), 
      where("guid", "==", accountguid)
    ); 
    const accSnap = await getDocs(accQuery); 
    let accountInfo = {};
    if (!accSnap.empty) {
      const d = accSnap.docs[0];
      accountInfo = {
        account_id: d.id,
        ...d.data()
      };
    }

    const staffData = staffSnap.docs[0].data();

    return { success: true, data: staffData, accountinfo: accountInfo };

  } catch (err) {
    return {
      success: false,
      error: err?.message || "Unknown error"
    };
  }
};
